



























































































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { required, helpers, sameAs } from 'vuelidate/lib/validators';
import DropdownLight from '@/shared/dropdown-light/dropdown-light.vue';
import RegexValidators from '@/shared/regex-validators';
import { confirmService, ConfirmOptions, ConfirmButton } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import jsEncrypt from '@/shared/jsEncrypt';
import { CreateElement, VNode } from 'vue';
import { RootStoreState } from '@/store';
import { State } from 'vuex-class';
import { envCongif } from '@/shared/env.config';

const domainPattern = helpers.regex('addressCheck', new RegExp(RegexValidators.domainPattern));
const passwordPattern = helpers.regex('addressCheck', new RegExp(RegexValidators.passwordPattern));

@Component({
  components: {
    ...UUIFComponent,
    DropdownLight,
  },
  validations: {
    hostedEmailSecurity: {
      dataCenter: { required },
      domainName: { required, domainPattern },
      reDomainName: { sameAsDomainName: sameAs('domainName') },
      inboundMailServerIP: { required },
      outboundMailServerIP: {},
      ispConnect: {},
      emailAddress: {},
      password: { required, passwordPattern },
      rePassword: { sameAsPassword: sameAs('password') },
    },
  },
})
export default class HostedEmailSecurity extends SwExtendedVue {
  @State((state: RootStoreState) => state.MswProductsStoreModule.selectedSerialNumer)
  serialNo: string;
  dataCenterLocationList: any[] = [];
  hostedEmailSecurity: {
    dataCenter: string,
    domainName: string,
    reDomainName: string,
    inboundMailServerIP: string,
    outboundMailServerIP: string,
    ispConnect: string,
    emailAddress: string,
    password: string,
    rePassword: string,
    isOutBoundChecked: boolean,
  } = {
    dataCenter: '',
    domainName: '',
    reDomainName: '',
    inboundMailServerIP: '',
    outboundMailServerIP: '',
    ispConnect: '',
    emailAddress: '',
    password: '',
    rePassword: '',
    isOutBoundChecked: false,
  };
  submitted: boolean = false;
  errorMessage: string = '';
  sharedOutBound: any = {};
  serialNumber: any = '';
  ispConnectList: any = [];
  registrationSuccess: boolean = false;
  completionResponse: any;
  isDomainOverride: boolean = false;
  options: ConfirmOptions;
  buttons: ConfirmButton[] =  [
    { key: 'cancel', name: 'Cancel', isDefault: true },
    { key: 'yes', name: 'Yes' },
  ];

  get getSerialFromQueryParameter() {
    return (this.$route.query.SN ||
      this.$route.query.serial ||
      this.$route.query.serialNumber) &&
      (this.$route.query.SN.toString() ||
      this.$route.query.serialNumber.toString() ||
      this.$route.query.serial.toString()) || '';
  }

  mounted() {
    this.serialNumber = this.getSerialFromQueryParameter || this.serialNo;
    Promise.all([
      this.$store.dispatch('MswProductsStoreModule/getHESDataCenter'),
      this.$store.dispatch('MswProductsStoreModule/getHESSerialNumberDetail', { serialNumber: this.serialNumber }),
    ])
    .then((res: any) => {
      this.$store.commit('stopLoading');
      this.dataCenterLocationList = [];
      let selectedDataCenter: any;
      this.dataCenterLocationList = res[0].content.HESDatacenter.map((element: any) => {
        if (element.isDefault) {
          selectedDataCenter = element;
        }
        if (element.sharedOutBound) {
          this.sharedOutBound[element.dataCenterLocationId] = element.sharedOutBound.map((each: any) => {
            return { label: each.textSourceISP, value: each.textSourceISP, id: each.textSourceISP };
          });
        }
        return { label: element.dataCenterName, value: element.dataCenterLocationId, id: element.dataCenterLocationId };
      });
      this.hostedEmailSecurity = {
        dataCenter: selectedDataCenter.dataCenterLocationId || '',
        domainName: res[1].content.dominName || '',
        emailAddress: res[1].content.hesEmailAddress || '',
        inboundMailServerIP: res[1].content.hostEmailIpAddress || '',
        outboundMailServerIP: res[1].content.sourceIpAddress || '',
        ...this.hostedEmailSecurity,
      };
    });
  }
  dataCenterChanged() {
    if (this.sharedOutBound[this.hostedEmailSecurity.dataCenter]) {
      this.ispConnectList = this.sharedOutBound[this.hostedEmailSecurity.dataCenter];
      this.hostedEmailSecurity = {
        ispConnect: this.ispConnectList[0].value,
        password: '',
        rePassword: '',
        outboundMailServerIP: '',
        ...this.hostedEmailSecurity,
      };
    } else {
      this.ispConnectList = [];
      this.hostedEmailSecurity = {
        isOutBoundChecked: false,
        password: '',
        rePassword: '',
        outboundMailServerIP: '',
        ...this.hostedEmailSecurity,
      };
    }
  }
  ispFilterToggle() {
    if (this.hostedEmailSecurity.isOutBoundChecked) {
      this.ispConnectList = this.sharedOutBound[this.hostedEmailSecurity.dataCenter];
      this.hostedEmailSecurity.ispConnect = this.ispConnectList[0].value;
    } else {
      this.hostedEmailSecurity.outboundMailServerIP = '';
    }
  }
  validateForm() {
    this.submitted = true;
    this.errorMessage = '';
    this.$v.$touch();
    if (!this.$v.$invalid) {
      const body = {
        dataCenter: this.dataCenterLocationList.filter((each: any) => {
            return each.value === this.hostedEmailSecurity.dataCenter;
        })[0].label,
        domainName: this.hostedEmailSecurity.domainName,
        inBoundMailServerIpAddres: this.hostedEmailSecurity.inboundMailServerIP,
        outBoundSourceIpAddress: this.hostedEmailSecurity.outboundMailServerIP,
        ispConnect: this.hostedEmailSecurity.ispConnect,
        emailAddress: this.hostedEmailSecurity.emailAddress,
        password: this.hostedEmailSecurity.password,
        serialNumber: this.serialNumber,
        isOutBoundChecked: this.hostedEmailSecurity.isOutBoundChecked,
        isDomainOverride: this.isDomainOverride,
        dataCenterValue: this.hostedEmailSecurity.dataCenter,
      };
      if (!body.isOutBoundChecked) {
        body.ispConnect = '';
      }
      this.options = {
        status: 'normal',
        title: 'Confirmation',
        message: (h: CreateElement): VNode => { // tslint:disable-line
          return (
            <div>
              <div class="confirmationField">
                <label>{this.$t('hostedEmailSecurity.dataCenterLocation')}</label>
                <div>{body.dataCenter}</div>
              </div>
              <div class="confirmationField">
                <label>{this.$t('hostedEmailSecurity.domainName')}</label>
                <div>{body.domainName}</div>
              </div>
              <div class="confirmationField">
                <label>{this.$t('hostedEmailSecurity.inboundMailServerIP')}</label>
                <div>{body.inBoundMailServerIpAddres}</div>
              </div>
              <div class={body.outBoundSourceIpAddress.length > 0 ? 'confirmationField' : 'hidden'}>
                <label>{this.$t('hostedEmailSecurity.outboundMailServerIP')}</label>
                <div>{body.outBoundSourceIpAddress}</div>
              </div>
              <div class={body.isOutBoundChecked ? 'confirmationField' : 'hidden'}>
                <label>{this.$t('hostedEmailSecurity.ispConnect')}</label>
                <div>{body.ispConnect} {body.isOutBoundChecked} </div>
              </div>
              <div class="confirmationField">
                <label>{this.$t('hostedEmailSecurity.emailAddress')}</label>
                <div>{body.emailAddress}</div>
              </div>
              <div class="confirmationField">
                <label>{this.$t('hostedEmailSecurity.password')}</label>
                <div>{body.password}</div>
              </div>
            </div>
          ) as VNode;
        },
        buttons: this.buttons,
      };
      confirmService.confirm(this.options)
      .then((key: any) => {
        if (key === 'yes') {
          body.password = jsEncrypt
          .getEncryptObj_msw()
          .encrypt(body.password);
          this.activateHES(body);
        }
      });
    }
  }
  activateHES(request: any) {
    this.$store.dispatch('MswProductsStoreModule/activateHES', request)
    .then((res: any) => {
      this.$store.commit('stopLoading');
      if (res.msgCode === 'MSWAPP:SUCCESS') {
        this.registrationSuccess = true;
        this.completionResponse = res.content;
      } else if (res.msgCode === 'MSWAPP:MXRECFETCHERROR') {
        this.registrationSuccess = true;
        this.completionResponse = res.content;
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
      } else {
        const errorMsg = res.msgDesc.replace('{0}', request.domainName);
        this.$store.commit('enqueueMessage', { infoType: (res.msgCode === 'MSWAPP:DOMAINDOESNTEXIST' || res.msgCode === 'MSWAPP:NOMXRECORDS' ? 'major' : 'failed'), infoMsg: errorMsg });
        if (res.msgCode === 'MSWAPP:DOMAINDOESNTEXIST' || res.msgCode === 'MSWAPP:NOMXRECORDS') {
          this.isDomainOverride = true;
        }
      }
    });
  }
  setDC(dc: string) {
    this.hostedEmailSecurity.dataCenter = dc;
    this.dataCenterChanged();
  }
  changeISPConnect(ispConnect: string) {
    this.hostedEmailSecurity.ispConnect = ispConnect;
  }
  domainNameChangeHandler() {
    if (this.hostedEmailSecurity.domainName !== '') {
      this.hostedEmailSecurity.emailAddress = `admin@${this.hostedEmailSecurity.domainName}`;
    } else {
      this.hostedEmailSecurity.emailAddress = this.hostedEmailSecurity.domainName;
    }
  }

  async goToHESConsole() {
    try {
      const res = await this.$store.dispatch('MswProductsStoreModule/goToHESConsole',  { serialNumber: this.serialNumber });
      if (res.content.tenantId) {
        const urlObj = new URL(res.content.url);
        const resp = await this.$store.dispatch('MswProductsStoreModule/generateCSCCode', {
          tenant: res.content.tenantId,
          tileName: 'ISHESSAFEENABLED',
        });
        const newToken = resp.content ? resp.content.accessCode : '';
        if (newToken) {
          urlObj.searchParams.set('code', newToken);
        }

        const spogSrc = `${envCongif.spog_url}/workspace/m/feature/spog-homepage?embed=YES&tenant=${res.content.tenantId}`;
        urlObj.searchParams.set('spogSrc', btoa(spogSrc));

        urlObj.searchParams.set('viewMode', 'CLOUDEMAIL');
        urlObj.searchParams.set('caller', 'MSW');
        const updatedUrl = urlObj.toString();
        window.open(updatedUrl, '_blank');
      } else if (res.content.errmsg) {
        this.$store.commit('enqueueMessage', {
          infoType: 'failed',
          infoMsg: res.content.errmsg,
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.$store.commit('stopLoading');
    }
  }

  goToServiceManagement() {
    this.$router.push({ path: `/m/feature/products?serialNumber=${this.serialNumber}` });
    window.parent.postMessage({
      redirectUrl : `/m/feature/products?serialNumber=${this.serialNumber}`,
    },                        '*');
  }
}
